import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class AudienceSegmentSelection extends React.Component {
  constructor(props) {
    super(props)
  }


  render() {
    const { classes, theme } = this.props;

    return (
      <div className={classes.root}>
        <Select
          placeholder='Select Segments'
          multiple
          fullWidth
          value={this.props.selectedData === null ? [] : this.props.selectedData}
          onChange={(e) => {this.props.onSelectedData(e.target.value)}}
          input={<Input id="select-multiple-chip" />}
          renderValue={selected => (
            <div className={classes.chips}>
              {selected.map(obj => {
                for (let item of this.props.audienceSegments) {
                  if (item.value === obj) {
                    return (
                      <Chip key={item.id} label={item.label} className={classes.chip} />
                    )
                  }
                }
              }
              )}
            </div>
          )}
          MenuProps={MenuProps}
        >
          {this.props.audienceSegments.map((obj) => {
            return (
              <MenuItem
                key={obj.id}
                value={obj.value}
              >
                {obj.label}
              </MenuItem>
            )
          })}
        </Select>
      </div>
    );
  }
}

AudienceSegmentSelection.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(AudienceSegmentSelection);



// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/components/audienceSegmentSelection/audienceSegmentSelection.js